import { MessageCardAction } from '@interfaces/message-card-action.interface';

export class ContentMessage {
  public id?: number;
  public message_title?: string;
  public message_sub_header?: string;
  public text?: string;
  public icon?: string;
  public link?: string;
  public button_text?: string;
  public internal_link?: boolean;
  public actions?: MessageCardAction[];

  constructor(data: ContentMessage) {
    data = data || {};
    this.id = data.id || null;
    this.message_title = data.message_title || null;
    this.message_sub_header = data.message_sub_header || null;
    this.text = data.text || null;
    this.icon = data.icon || null;
    this.link = data.link || null;
    this.button_text = data.button_text || null;
    this.internal_link = data.internal_link || null;
    this.actions = this.actions || [];
  }
}
